// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__eUuRn","column":"style_column__3mspq","row":"style_row__1-MVc"};